<div class="main-content">
  <div class="main-content">
    <img src="assets/branded/img/maintenance-bg.png" [alt]="'common.alt-image' | transloco" />
    <div class="content ion-padding">
      <div>
        <div class="title">{{ 'maintenance.title' | transloco | uppercase }}</div>
        <div class="description" innerHTML="{{ 'maintenance.description' | transloco : { minutes, end } }}"></div>
      </div>
      <c-button (action)="close()">
        {{ 'common.understand' | transloco }}
      </c-button>
    </div>
  </div>
</div>
